// src/pages/treatments/OralAndMaxillofacialSurgery.jsx
import { Link } from 'react-router-dom';
import OMST7 from '../../Assets/Opimages/OMST7.webp'
import OM from '../../Assets/Opimages/O&M.webp'
const OralAndMaxillofacialSurgery = () => {
  return (
    <main className="pt-20 md:pt-24 min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative h-80 md:h-[500px] flex items-center justify-center bg-blue-50">
        <div className="absolute inset-0">
          <img
            src={OMST7}
            alt="Oral & Maxillofacial Surgery"
            className="w-full h-full object-cover brightness-75"
          />
          {/* Overlay */}
      <div className="absolute inset-0 bg-black/50" />
        </div>
        <div className="relative z-10 text-center text-white px-6">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 tracking-tight">
            Oral & Maxillofacial Surgery
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto font-light">
            Advanced surgical solutions for oral health
          </p>
        </div>
      </section>

      {/* Breadcrumb */}
      {/* <div className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-6 py-4 flex flex-wrap items-center text-sm text-gray-600">
          <Link to="/" className="hover:text-blue-600 transition">Home</Link>
          <span className="mx-2">›</span>
          <Link to="/treatments" className="hover:text-blue-600 transition">Treatments</Link>
          <span className="mx-2">›</span>
          <span className="text-blue-600 font-medium">Oral & Maxillofacial Surgery</span>
        </div>
      </div> */}

      {/* Main Content – Flex Layout */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
            {/* Image Section */}
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src={OM}
                alt="Oral & Maxillofacial Surgery Procedure"
                className="w-full max-w-md rounded-2xl shadow-xl object-cover"
              />
            </div>

            {/* Text Content */}
            <div className="w-full lg:w-1/2 flex flex-col">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Oral and Maxillofacial Surgery
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Oral and maxillofacial surgery is an internationally recognized specialty for face reconstruction, facial trauma surgery, jaws, face, neck, and mouth. This surgery is performed under sedation or anesthesia, as it fixes numerous conditions. Oral surgery procedures such as Tooth extraction, impactions (wisdom/third molar teeth ), cyst removals, orthognathic surgery ( jaw repositioning ), Bone grafting, sinus augmentation are being regularly done at our sophisticated clinic.
              </p>

              {/* CTA */}
              <div className="flex justify-start">
                <Link to="/book-appointment" className="bg-blue-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-blue-700 transition">
                  Book Appointment
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default OralAndMaxillofacialSurgery;